import { render, staticRenderFns } from "./VideoLibWidget.vue?vue&type=template&id=aa8f6c76&scoped=true&xmlns%3Av-clipboard=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./VideoLibWidget.vue?vue&type=script&lang=js&"
export * from "./VideoLibWidget.vue?vue&type=script&lang=js&"
import style0 from "./VideoLibWidget.vue?vue&type=style&index=0&id=aa8f6c76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8f6c76",
  null
  
)

export default component.exports